import React from "react";

function Filter({ color, height, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 22 23"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M15.767 12.716h-10.5c-.525 0-.875-.366-.875-.916s.35-.917.875-.917h10.5c.525 0 .875.367.875.917s-.35.916-.875.916zM13.142 18.216h-5.25c-.525 0-.875-.367-.875-.917s.35-.916.875-.916h5.25c.525 0 .875.367.875.916 0 .55-.35.917-.875.917zM18.392 7.216H2.642c-.525 0-.875-.367-.875-.917s.35-.916.875-.916h15.75c.525 0 .875.366.875.916s-.35.917-.875.917z"
      ></path>
    </svg>
  );
}

export default Filter;
